// redux/slices/guideFeedbackSlice.js (web)
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "../../Utils/apiClient";
import { resetStore } from "./resetStore";

const errorText = (error) =>
  error?.response?.data?.error || error?.response?.data?.message || error?.message || "Request failed";

export const fetchGuideFeedback = createAsyncThunk(
  "guideFeedback/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const result = (await apiRequest("GET", "/guide-feedback"))?.data;
      return Array.isArray(result?.items) ? result.items : [];
    } catch (error) {
      return rejectWithValue(errorText(error));
    }
  },
);

export const voteGuideArticle = createAsyncThunk(
  "guideFeedback/vote",
  async ({ articleKey, vote }, { rejectWithValue }) => {
    try {
      if (typeof articleKey !== "string" || ![-1, 0, 1].includes(vote)) {
        throw new Error("Invalid article or vote");
      }
      return (await apiRequest("PUT", `/guide-feedback/${encodeURIComponent(articleKey)}`, { vote }))?.data;
    } catch (error) {
      return rejectWithValue(errorText(error));
    }
  },
);

const initialState = { byKey: {}, status: "idle", pendingByKey: {}, errorByKey: {}, error: null };

const guideFeedbackSlice = createSlice({
  name: "guideFeedback",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGuideFeedback.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchGuideFeedback.fulfilled, (state, action) => {
        state.status = "succeeded";
        for (const item of action.payload) {
          // Не затираем оценку, которую пользователь уже успел поставить.
          if (state.pendingByKey[item.articleKey]) continue;
          state.byKey[item.articleKey] = item;
        }
      })
      .addCase(fetchGuideFeedback.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(voteGuideArticle.pending, (state, action) => {
        const key = action.meta.arg.articleKey;
        state.pendingByKey[key] = true;
        delete state.errorByKey[key];
      })
      .addCase(voteGuideArticle.fulfilled, (state, action) => {
        const key = action.meta.arg.articleKey;
        state.byKey[key] = action.payload;
        state.pendingByKey[key] = false;
      })
      .addCase(voteGuideArticle.rejected, (state, action) => {
        const key = action.meta.arg.articleKey;
        state.pendingByKey[key] = false;
        state.errorByKey[key] = action.payload || true;
      })
      .addCase(resetStore, () => ({ ...initialState, byKey: {}, pendingByKey: {}, errorByKey: {} }));
  },
});

export default guideFeedbackSlice.reducer;
